<template>
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useStore, mapState } from "vuex";
import * as core from "@/common/utils/core";

export default defineComponent({
  name: "App",
  setup() {
    const store = useStore();
    return {
      store,
    };
  },

  data() {
    return {
      //
    };
  },
  components: {},
  computed: {
    //
  },
  methods: {
    //
  },
  async created() {
    console.info("[App] created");
    // this.getCore().sessionCheck();
    // core.sessionCheck();
  },
});
</script>
